// extracted by mini-css-extract-plugin
export default {"footer":"cpGSw","buttonLeft":"XLNuB","buttonRight":"vcNcg"};